import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Introduction from "../../components/Introduction";
import "./ClassesPage.css";
import Loader from "../../components/Loader";
import config from "../../config";
import useFetch from "../../hooks/useFetch";
import DefaultPage from "../DefaultPage/DefaultPage";
import { useState } from "react";
import ButtonV2 from "../../components/ButtonV2";
import { Link } from "react-router-dom";

const ClassesPage = () => {
  const [selectedYear, setSelectedYear] = useState();
  const {
    loading: loadingSchoolYears,
    error: errorSchoolYears,
    data: schoolYears,
  } = useFetch(`${config.api}/api/school-years?sort[0]=name`);

  const classesFetchUrl = `${config.api}/api/classes?populate=schoolYear&filters[schoolYear][name][$eq]=${selectedYear}`;

  const {
    data: classesData,
    loading: loadingClasses,
    error: errorClasses,
  } = useFetch(classesFetchUrl);

  if (loadingSchoolYears) return <Loader />;
  if (loadingClasses) return <Loader />;

  if (errorSchoolYears || errorClasses)
    return <DefaultPage message="Chyba při načítání tříd" />;

  //změna titulku stránky v prohlížeči
  document.title = "Třídy";
  return (
    <div className="min-height-100 d-flex flex-column container-fluid background-white">
      <Navbar />
      <Introduction title="Třídy" />
      <div className="container-fluid sub-nav">
        <div className="container d-flex flex-column flex-sm-row align-items-center justify-content-center flex-wrap gap-2 mb-2">
          {schoolYears?.data?.map((year) => (
            <ButtonV2
              key={year.id}
              text={year.name}
              onPress={setSelectedYear}
            />
          ))}
        </div>
      </div>
      <div className="container container-background d-flex flex-column align-items-center p-5">
        <h1>{selectedYear ? selectedYear : "Vyberte školní rok"}</h1>
        {classesData?.data?.map((cls) => (
          <ClassCard props={cls} key={cls.id} />
        ))}
      </div>
      <Footer />
    </div>
  );
};
export default ClassesPage;

const ClassCard = ({ props }) => (
  <Link
    to={`/trida/${props.documentId}`}
    className="class-card d-flex justify-content-between"
  >
    <h2>{props.name}</h2>
    <img src="/images/chevron-right.svg" alt="odkaz" />
  </Link>
);
